import {TurboForm} from "../../js/lib/TurboForm"

document.querySelectorAll('.js-form').forEach(function (item) {
    let form = new TurboForm(item, {
        errorClass: 'form-error__field',
        fieldLineClass: 'form-error',
        errorMsgClass: 'form-error__message',
        showErrorAfterInput: true,
        messageBoxSelector: '.form-success-message'
    })

    form.showSuccessMessage = function(message) {
        const successPopup = document.querySelector('.success-popup')
        successPopup.querySelector('.js-success-title').textContent = message.title
        successPopup.querySelector('.js-success-message').textContent = message.content
        document.querySelector('.js-button-success').click()
        form.form.reset()
    };
});
